import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent, IconButton, Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InterviewConversation from './InterviewConversation';

/**
 * Modal shell for the interview — the "in-context bite" surface (design §12).
 * Mounted from the dashboard "continue" card. Closing mid-bite is safe (the session
 * persists continuously). Offers a "continue in full view" promote to the page.
 *
 * Props: open, onClose, entryMode ('backfill' | 'now')
 */
const InterviewModal = ({ open, onClose, entryMode }) => {
  const navigate = useNavigate();

  const promote = () => {
    onClose?.();
    navigate(entryMode === 'now' ? '/interview?mode=now' : '/interview');
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth
      PaperProps={{ sx: { height: '80vh', display: 'flex', flexDirection: 'column' } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.5 }}>
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            {entryMode === 'now' ? 'What are you working on now?' : 'A quick bite'}
          </Typography>
          <Typography variant="caption" sx={{ color: '#6b7280' }}>~5 minutes — stop anytime, it's saved.</Typography>
        </Box>
        <IconButton onClick={onClose} aria-label="Close"><CloseIcon /></IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0, flex: 1, minHeight: 0 }}>
        {open && <InterviewConversation variant="modal" entryMode={entryMode} onPromote={promote} />}
      </DialogContent>
    </Dialog>
  );
};

export default InterviewModal;
